import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
Vue.use(VueResource)
Vue.use(VueCookies)

var vm, project
// ================
Vue.http.options.root = process.env.VUE_APP_DAPI_URL + "/"
Vue.http.interceptors.push(function (_request, _next) {
    // 從 cookie 獲取 token
    const token = Vue.$cookies.get('api-token')

    // 設置 Authorization header（如果有 token）
    if (token) {
        Vue.http.headers.common['Authorization'] = 'Bearer ' + token
    } else {
        // 沒有 token 時清除 header
        delete Vue.http.headers.common['Authorization']
    }

    Vue.http.headers.common['Content-Type'] = 'application/json'

    // 處理一般程序
    _next(function (_response) {
        var data = _response.body

        // 處理 401 錯誤（Token 無效）
        if (_response.status === 401) {
            // 清除登入狀態
            project.common.setCookie("api-token", "")
            project.common.setCookie("user", "")
            project.common.setCookie("login", "")
            if (project.$root) {
                project.$root.login = false
                // 跳轉到登入頁
                if (project.$router) {
                    project.$router.push("/login")
                }
            }
            return
        }

        // console.log('執行錯誤檢查: ' + data.error_code)
        if (data) {
            switch (data.code) {
                case "1080":
                    // 彈出警告視窗
                    project.common.blockAction()
                    break
                case "1079":
                    vm.issueToken()
                default:
                    break
            }
        }
    })
})

export default class Apis {
    constructor(_vm) {
        vm = this
        project = _vm
    }

    /**
     * 請求確認目前裝置 Token 的狀態
     * @param {*} _success 
     * @param {*} _error 
     * @returns 
     */
    async confirmToken (_success, _error) {
        if (!project.auth_token) {
            return this.issueToken()
        }

        this.getTokenDetail(_success, function (_response) {
            // 准予可以自行更換 Token 的錯誤
            if (["1078", "1079"].indexOf(_response.body.code) > -1) {
                vm.issueToken()
            }
        })
    }

    /**
     * 請求獲取新的 Token
     * @param {*} _success 
     * @param {*} _error 
     */
    async issueToken (_success, _error) {
        await Vue.http.get("token").then(function (_response) {
            console.log("=> 取得新的 Token: " + _response.body.token);
            project.common.setCookie("api-token", _response.body.token)
            project.auth_token = _response.body.token
            vm.getTokenDetail()
        }, _error)
    }

    /**
     * 取得目前 Token 相關資訊
     * @param {*} _success 
     * @param {*} _error 
     */
    async getTokenDetail (_success, _error) {
        await Vue.http.get("token/status").then(function (_response) {
            let response = _response.body.data

            // 如果已經登入
            if (response.bind) {
                vm.getMemberInfo()
            }

            // 如果 Token 被綁定中, 且並未遭到封鎖
            project.login_status = (!response.block && response.bind) ? true : false
            // 設定後台系統啟用完成
            project.system_ready = true
        }, _error)
    }

    async getPluginTypes (_page, _success, _error) {
        await Vue.http.get('plugin/voices/type/list', { params: { page: _page } }).then(_success, _error)
    }

    async createPluginType (_data, _success, _error) {
        await Vue.http.post('plugin/voices/type/create', _data).then(_success, _error)
    }

    async getPluginThemes (_itemId, _page, _success, _error) {
        await Vue.http.get('plugin/voices/themes/' + _itemId + '/list', { params: { page: _page } }).then(_success, _error)
    }

    async createPluginTheme (_itemId, _data, _success, _error) {
        await Vue.http.post('plugin/voices/theme/' + _itemId + '/create', _data).then(_success, _error)
    }

    async getPluginTopics (_themeId, _success, _error) {
        await Vue.http.get('plugin/voices/topics/' + _themeId + '/list').then(_success, _error)
    }

    async createPluginTopics (_themeId, _data, _success, _error) {
        await Vue.http.post('plugin/voices/topic/' + _themeId + '/create', _data).then(_success, _error)
    }

    async getTypeItem (_typeId, _success, _error) {
        await Vue.http.get('plugin/voices/type/' + _typeId).then(_success, _error)
    }

    async delTypeItem (_typeId, _success, _error) {
        await Vue.http.delete('plugin/voices/type/' + _typeId).then(_success, _error)
    }

    async delThemeItem (_themeId, _success, _error) {
        await Vue.http.delete('plugin/voices/theme/' + _themeId).then(_success, _error)
    }

    async delTopicItem (_topicId, _success, _error) {
        await Vue.http.delete('plugin/voices/topic/' + _topicId).then(_success, _error)
    }

    async putTypeItem (_typeId, _data, _success, _error) {
        await Vue.http.put('plugin/voices/type/' + _typeId, _data).then(_success, _error)
    }

    async putThemeItem (_themeId, _data, _success, _error) {
        await Vue.http.put('plugin/voices/theme/' + _themeId, _data).then(_success, _error)
    }

    async putTopicItem (_topicId, _data, _success, _error) {
        await Vue.http.put('plugin/voices/topic/' + _topicId, _data).then(_success, _error)
    }

    async generateVoice (_data, _success, _error) {
        await Vue.http.post("plugin/voices/generate", _data).then(_success, _error)
    }

    async setTopicSort (_themeId, _data, _success, _error) {
        await Vue.http.post("plugin/voices/topics/" + _themeId + "/sort", _data).then(_success, _error)
    }

    async getMemberRecordList (_searchData, _success, _error) {
        await Vue.http.get('plugin/users/analysis', { params: _searchData }).then(_success, _error)
    }

    async getMemberRecordDetail (_searchData, _success, _error) {
        await Vue.http.get('plugin/users/records', { params: _searchData }).then(_success, _error)
    }

    async getMemberInformation (_memberId, _success, _error) {
        await Vue.http.get('plugin/users/' + _memberId + '/detail').then(_success, _error)
    }

    async getMemberUseSecondByMonth (_memberId, _searchMonth, _success, _error) {
        await Vue.http.get('plugin/users/' + _memberId + '/useMonth', { params: { month: _searchMonth } }).then(_success, _error)
    }

    async setThemeCTA (_themeId, _data, _success, _error) {
        await Vue.http.post('plugin/voices/theme/' + _themeId + '/cta', _data).then(_success, _error)
    }

    async getUnitRecordList (_page, _success, _error) {
        await Vue.http.get('plugin/units/list', { params: { page: _page } }).then(_success, _error)
    }

    async getUnitRecords (_themeId, _topicId, _page, _success, _error) {
        await Vue.http.get('plugin/units/topics/records', { params: { theme_id: _themeId, topic_id: _topicId, page: _page } }).then(_success, _error)
    }

    async exportMemberHistoryRecords (_memberId, _success, _error) {
        await Vue.http.get('plugin/users/export', {
            params: { member_id: _memberId },
            responseType: 'blob'
        }).then(_success, _error)
    }

    // ============ 認證相關 API ============
    /**
     * 登入
     */
    async login (_data, _success, _error) {
        await Vue.http.post('auth/login', _data).then(_success, _error)
    }

    /**
     * 登出
     */
    async logout (_success, _error) {
        await Vue.http.post('auth/logout', {}).then(_success, _error)
    }

    /**
     * 獲取當前使用者資訊
     */
    async getMe (_success, _error) {
        await Vue.http.get('auth/me', {}).then(_success, _error)
    }

    // ============ 管理員帳號管理 API ============
    /**
     * 獲取管理員列表
     */
    async getManagers (_searchData, _success, _error) {
        const params = {
            search: _searchData.search || '',
            page: _searchData.page || 1
        }
        await Vue.http.get('managers/list', { params: params }).then(_success, _error)
    }

    /**
     * 創建管理員
     */
    async createManager (_data, _success, _error) {
        await Vue.http.post('managers/create', _data).then(_success, _error)
    }

    /**
     * 更新管理員
     */
    async updateManager (_id, _data, _success, _error) {
        await Vue.http.put(`managers/${_id}`, _data).then(_success, _error)
    }

    /**
     * 刪除管理員
     */
    async deleteManager (_id, _success, _error) {
        await Vue.http.delete(`managers/${_id}`, {}).then(_success, _error)
    }

    /**
     * 切換管理員狀態
     */
    async toggleManagerStatus (_id, _success, _error) {
        await Vue.http.put(`managers/${_id}/status`, {}).then(_success, _error)
    }
}